import React from 'react';
import { DialogContent } from '@mui/material';

export const StyledDialogContent: React.FC<{ children: React.ReactNode }> = (
    props
) => {
    return (
        <DialogContent sx={{paddingTop: '10px !important'}}>
            {props.children}
        </DialogContent>
    );
};
